<div
  class="integration-connected-row"
  [class.integration-connected-row--with-status]="!!integration.status"
>
  <div class="integration-connected-row__info">
    <div
      class="integration-connected-row__logo"
      [class.integration-connected-row__logo--company]="scope === 'company'"
      [class.integration-connected-row__logo--user]="scope === 'user'"
    >
      <mat-icon
        class="integration-logo"
        [svgIcon]="integration.logo"
        aria-hidden="true"
      ></mat-icon>
    </div>
    <div class="integration-connected-row__text">
      <p class="integration-connected-row__name">{{ integration.name }}</p>
      @if (integration.username) {
        <p class="integration-connected-row__username">
          {{ integration.username }}
        </p>
      }
    </div>
  </div>

  @if (integration.status) {
    <div
      class="integration-connected-row__status"
      [class.integration-connected-row__status--expired]="isExpiredStatus"
      [class.integration-connected-row__status--unknown]="isUnknownStatus"
      [class.integration-connected-row__status--connected]="isConnectedStatus"
    >
      <ng-container
        *ngTemplateOutlet="statusIndicator; context: { showLabel: true }"
      />
    </div>
  }

  <div class="integration-connected-row__actions">
    <div class="integration-connected-row__actions-desktop">
      @if (!hideManage) {
        <button
          rv-button
          variant="secondary"
          type="button"
          (click)="manage.emit(integration)"
        >
          Manage
        </button>
      }
      @if (integration.canReconnect) {
        <button
          rv-button
          variant="secondary"
          type="button"
          (click)="reconnect.emit(integration)"
        >
          Reconnect
        </button>
      }
      <button
        type="button"
        matButton="outlined"
        class="integration-connected-row__disconnect button-role--danger"
        (click)="disconnect.emit(integration)"
      >
        Remove
      </button>
    </div>

    <div class="integration-connected-row__actions-mobile">
      @if (integration.status) {
        <button
          type="button"
          class="integration-connected-row__status-trigger"
          [class.integration-connected-row__status-trigger--expired]="
            isExpiredStatus
          "
          [class.integration-connected-row__status-trigger--unknown]="
            isUnknownStatus
          "
          [matTooltip]="statusLabel"
          matTooltipPosition="below"
          matTooltipClass="menu-tooltip"
          #statusTooltip="matTooltip"
          (click)="statusTooltip.toggle()"
          [attr.aria-label]="'Status: ' + statusLabel"
        >
          <ng-container
            *ngTemplateOutlet="statusIndicator; context: { showLabel: false }"
          />
        </button>
      }
      <button
        type="button"
        mat-icon-button
        class="integration-connected-row__menu-trigger"
        [class.menu-is-open]="actionsMenuTrigger.menuOpen"
        [matMenuTriggerFor]="actionsMenu"
        #actionsMenuTrigger="matMenuTrigger"
        [attr.aria-label]="'More options for ' + integration.name"
      >
        <span class="integration-connected-row__menu-trigger-icon">
          <mat-icon
            svgIcon="more-vertical"
            class="integration-connected-row__menu-icon"
            aria-hidden="true"
          />
        </span>
      </button>
      <mat-menu
        #actionsMenu="matMenu"
        classList="integration-connected-row-menu"
        [attr.aria-label]="'Actions for ' + integration.name"
      >
        @if (!hideManage) {
          <button
            mat-menu-item
            type="button"
            class="integration-connected-row-menu__item"
            (click)="manage.emit(integration)"
          >
            <mat-icon
              svgIcon="pencil-line"
              class="small"
              aria-hidden="true"
            ></mat-icon>
            <span>Manage</span>
          </button>
        }
        @if (integration.canReconnect) {
          <button
            mat-menu-item
            type="button"
            class="integration-connected-row-menu__item"
            (click)="reconnect.emit(integration)"
          >
            <mat-icon
              svgIcon="refresh"
              class="small"
              aria-hidden="true"
            ></mat-icon>
            <span>Reconnect</span>
          </button>
        }
        <button
          mat-menu-item
          type="button"
          class="integration-connected-row-menu__item integration-connected-row-menu__item--danger"
          (click)="disconnect.emit(integration)"
        >
          <mat-icon svgIcon="trash" class="small" aria-hidden="true"></mat-icon>
          <span>Remove</span>
        </button>
      </mat-menu>
    </div>
  </div>
</div>

<ng-template #statusIndicator let-showLabel="showLabel">
  @if (isExpiredStatus) {
    <mat-icon
      class="integration-connected-row__status-icon"
      svgIcon="warning"
      aria-hidden="true"
    ></mat-icon>
  } @else if (isUnknownStatus) {
    <mat-icon
      class="integration-connected-row__status-icon integration-connected-row__status-icon--unknown"
      svgIcon="alert-triangle"
      aria-hidden="true"
    ></mat-icon>
  } @else {
    <span
      class="integration-connected-row__status-dot"
      aria-hidden="true"
    ></span>
  }
  @if (showLabel) {
    <span class="integration-connected-row__status-label">{{
      statusLabel
    }}</span>
  }
</ng-template>
